import { useQuery } from '@tanstack/react-query';
import { pillarsApi, PillarDto } from '../api/pillars';

export function usePillars() {
  return useQuery<PillarDto[], Error>({
    queryKey: ['pillars'],
    queryFn: () => pillarsApi.list(),
  });
}
